<template>
  <v-container grid-list-xs class="pa-0">
    <v-layout row wrap>
      <v-flex
        xs12
        md6
        class="elevation-6 border-right text-xs-center offset-md3"
      >
        <v-card class="elevation-4">
          <v-card-title class="info white--text">
            <h2 class="headline">Log In</h2>
          </v-card-title>
          <PCForm :fields="fields" class="pa-3" @save="submit">
            <template v-slot:submit>
              <p class="text-xs-center">
                Don't have an account?
                <a @click="$router.push('register')">Register</a>
              </p>
              <p class="text-xs-center">
                Forgot Your Password?
                <a @click="recover()">Recover Password</a>
              </p>
              <v-btn block round color="info" class="mt-3" type="submit">
                <div class="loader" v-if="loading"></div>
                <span v-else>Log In</span>
              </v-btn>
            </template>
          </PCForm>
        </v-card>
        <v-snackbar v-model="snackbar.show" :bottom="true" :right="true">
          {{ snackbar.message }}
          <v-btn color="red" flat @click="snackbar = false">Close</v-btn>
        </v-snackbar>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PCForm from "@/components/PCForm";
export default {
  components: { PCForm },
  data() {
    return {
      fields: [
        {
          name: "Email",
          type: "email",
          value: "",
          classes: ["pl1", "xs12"],
        },
        {
          name: "Password",
          type: "password",
          value: "",
          classes: ["pl1", "xs12"],
        },
      ],
      loading: false,
      snackbar: {
        show: false,
        message: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      user: "user/getUser",
    }),
  },
  methods: {
    ...mapActions({
      login: "user/login",
      recoverPassword: "user/recoverPassword",
    }),
    async submit() {
      try {
        this.loading = true;
        await this.login({
          email: this.fields[0].value,
          password: this.fields[1].value,
        });
        this.$router.push({ name: "calculator.test" });
      } catch (err) {
        this.snackbar = { show: true, message: err.message };
        this.loading = false;
      }
    },
    async recover() {
      try {
        await this.recoverPassword(this.fields[0].value);
        this.snackbar = {
          show: true,
          message: "Please check your email for further instructions",
        };
      } catch (err) {
        if (!this.fields[0].value)
          this.snackbar = {
            show: true,
            message: "Please enter your email address",
          };
        else this.snackbar = { show: true, message: err.message };
      }
    },
  },
};
</script>
